

<template>
	<div>
		<vFormItem label="可使用仓库" label-width="150" v-if="type!=='query'">
			<vTransfer
				style="height:360px;"
				:data="getTransferHostWarehouse"
				identifier="value"
				:target-keys="targetKeys"
				:list-style="listStyle"
				:render-format="renderFormat"
                :filter-method="filterMethod"
				filterable
				@on-transfer="handleChange"
			></vTransfer>
		</vFormItem>
		<Table v-else v-bind="getTableProps"></Table>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: ['waredata','custype','wareOrgid'],
	data() {
		return {
			type: this.custype,
			id: this.$route.query.id,
			targetKeys: [],
			listStyle: {
				width: '30%',
				minWidth: '260px'
            },
		}
    },
	watch: {
		waredata: {
			immediate: true,
			handler(val) {
                this.targetKeys = (val || []).map(item => item.warehouseId);
			}
		}
	},
	computed: {
		...mapGetters('dictionary', ['getTransferHostWarehouse', ]),
		getTableProps() {
			return {
				data:this.waredata,
				columns: [{
					title: '序号',
					type: 'index',
					width: 100,
				}, {
					title: '仓库',
					key: 'warehouseCode',
					render: (h, { row }) => {
                        return <div>{row.warehouseCode}</div>
                    }
				}]
			}
		},
		
	},
	methods: {
		renderFormat(item) {
			return item.description ? `${item.label}-${item.description}` : item.label;
		},
		handleChange(targetKeys, direction, moveKeys) {
			// console.log(targetKeys)
			this.targetKeys = targetKeys;
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
	}
}
</script>